import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = () => ({
  container: {
    minWidth: 200
  }
});

class TeamMemberInfo extends React.PureComponent {
  render() {
    const { classes, member, visible, onClose } = this.props;
    return (
      <Dialog
        open={visible}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{member.displayName}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.container}
          >
            <i>Hi there!</i>
            <br />
            <strong>I am : </strong> {member.intro || "..."}
            <br />
            <strong>Looking for : </strong> {member.lookingFor || "..."}
            <br />
            <br />
            <i>
              Nice to meet you!{" "}
              <span role="img" aria-label="smile">
                🙂
              </span>
            </i>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(TeamMemberInfo);
